// Template scripts are blocked by the iframe sandbox, so the interactive
// widgets the template builder emits are re-implemented here.

function setupChips(doc) {
  doc.querySelectorAll('.look-chip').forEach((chip) => {
    chip.addEventListener('click', () => {
      const on = chip.getAttribute('aria-pressed') !== 'true'
      chip.setAttribute('aria-pressed', on ? 'true' : 'false')
      chip.classList.toggle('chip-on', on)
      chip.classList.toggle('chip-off', !on)
    })
  })
}

function setupFaq(doc) {
  const items = [...doc.querySelectorAll('.faq-item')]

  items.forEach((item) => {
    const button = item.querySelector('.faq-q')
    if (!button) return
    button.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false')

    button.addEventListener('click', () => {
      const wasOpen = item.classList.contains('open')
      items.forEach((other) => {
        other.classList.remove('open')
        other.querySelector('.faq-q')?.setAttribute('aria-expanded', 'false')
      })
      if (!wasOpen) {
        item.classList.add('open')
        button.setAttribute('aria-expanded', 'true')
      }
    })
  })
}

// Hash links do nothing in a srcdoc iframe, so scroll to the target ourselves.
function setupAnchorLinks(doc) {
  doc.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]')
    if (!link) return

    const href = link.getAttribute('href')
    if (!href || href === '#' || !href.startsWith('#')) return

    let id = href.slice(1)
    try {
      id = decodeURIComponent(id)
    } catch (e) {
      return
    }

    const target = doc.getElementById(id)
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  })
}

export function enhanceInteractions(doc) {
  setupChips(doc)
  setupFaq(doc)
  setupAnchorLinks(doc)
}
